

import {useStore} from "vuex";
import Event from "@/types/Event";
import {defineComponent, ref} from "vue";
import {
  IonNote,
  IonLabel,
  IonItem
} from "@ionic/vue";
import {sortEvents, filterEvents} from "@/tools/SortsAndFilters";
import moment from 'moment';
import { IonAccordion, IonAccordionGroup, IonButton } from '@ionic/vue';

export default defineComponent({
  name: "Accordion",
  props: {
    filter_type: [String],
    sort_type: String
  },
  components: {
    IonNote,
    IonLabel,
    IonItem,
    IonAccordion, 
    IonAccordionGroup
  },
  setup() {
    const accordionGroup = ref();
    const logAccordionValue = () => {
      if (accordionGroup.value) {
        console.log(accordionGroup.value.$el.value);
      }
    }
    const closeAccordion = () => {
      if (accordionGroup.value) {
        accordionGroup.value.$el.value = undefined;
      }
    }
    const store = useStore()
    return {
      accordionGroup,
      closeAccordion,
      logAccordionValue,
      isExpanded: "",
      store,
    };
  },
  created() {
    this.refreshEvents()
  },
  methods: {
    stringToDateDMY: function (date) {
      return moment(date,"DD-MM-YYYY").format("DD-MM-YYYY");
    },

    sort: function (list: Event[], sort: string): Event[] { return sortEvents(list, sort); },
    filter: function (list: Event[], filter: string[]): Event[] { return filterEvents(list, filter); },

    async refreshEvents() {
      console.debug("refreshing events")
      await this.store.dispatch('event/updateEvents')
          .then(() => {
            console.debug("setting this.events")
            this.events = this.store.getters['event/events'] as Event[]
            console.debug("this.events now is", this.events)
          })
          .catch((error) => {
            console.error("error loading events", error)
          })
      console.debug("finished data loading")

    },
  },
  data() {
    return {
      events: [] as Event[],
    };
  },
})
